(function(){
	'use strict';

	angular
		.module('app')
		.controller('AboutController', AboutController);

	function AboutController(API) {
		let vm = this;
		vm.actualTopic = 'our-history';
		vm.getTopicLinkClass = topic => ({'menu-list__item--active': topic === vm.actualTopic});
		vm.setTopic = topic => vm.actualTopic = topic;
		vm.scrollTop = () => $('body, html').animate({scrollTop: 0}, 600);
		vm.dismissLoader = true;

		vm.$onInit = () => {
			_loadPages()
		}

		function _loadPages() {
			API.get('paginas/12')
				.then(result => result.data[0])
				.then(history => vm.ourHistory = history)
				.then(() => vm.dismissLoader = false)
			API.get('paginas/13')
				.then(result => result.data[0])
				.then(institutional => vm.institutional = institutional)
			API.get('paginas/20')
				.then(result => result.data[0])
				.then(sustainability => vm.sustainability = sustainability)
			API.get('paginas/15')
				.then(result => result.data[0])
				.then(ourMission => vm.ourMission = ourMission)
			API.get('paginas/19')
				.then(result => result.data[0])
				.then(mainSustainability => vm.mainSustainability = mainSustainability)
			API.get('paginas/16')
				.then(result => result.data[0])
				.then(ourVision => vm.ourVision = ourVision)
			API.get('paginas/17')
				.then(result => result.data[0])
				.then(ourPosition => vm.ourPosition = ourPosition)
			API.get('paginas/18')
				.then(result => result.data[0])
				.then(politic => vm.politic = politic)
		}

	}

})();
